import { useEffect } from 'react';

/** Hero arama ve RFQ product_service placeholder döngüsü — aynı ürün listesi. */
export const TYPEWRITER_PRODUCTS = [
  'Pasta',
  'Wheat Flour',
  'Sunflower Oil',
  'Dried Fruits',
  'Bulgur',
  'Semolina',
  'Noodle',
  'Olive Oil',
  'Roasted Red Pepper',
  'Roasted Eggplant',
  'Stuffed Grape Leaves',
  'Jams',
  'Grape Leaves',
  'Tomato Paste',
  'Pickles',
  'Fruit Juices',
  'Confectionery',
  'Salt',
  'Energy Drink',
  'Iced Coffee',
  'Mineral Water',
  'Cement',
  'Ceramic & Porcelain Tile',
  'Marble',
  'Paint & Coating',
];

/**
 * @param {React.RefObject<HTMLInputElement|null>} inputRef
 * @param {boolean} active — false iken animasyon durur
 */
export function useTypewriterPlaceholder(inputRef, active) {
  useEffect(() => {
    const input = inputRef.current;
    if (!input || !active) return undefined;

    const products = TYPEWRITER_PRODUCTS;
    const TYPE_MS = 52;
    const DEL_MS = 34;
    const CYCLE_MS = 5000;
    let idx = 0;
    let chars = 0;
    let phase = 'typing';
    let timer;

    const go = (ms) => {
      clearTimeout(timer);
      timer = setTimeout(tick, ms);
    };

    const tick = () => {
      const word = products[idx];
      if (phase === 'typing') {
        if (chars < word.length) {
          chars += 1;
          input.placeholder = word.slice(0, chars);
          go(TYPE_MS);
          return;
        }
        phase = 'holding';
        go(Math.max(600, CYCLE_MS - word.length * TYPE_MS - word.length * DEL_MS));
        return;
      }
      if (phase === 'holding') {
        phase = 'deleting';
        go(120);
        return;
      }
      if (chars > 0) {
        chars -= 1;
        input.placeholder = word.slice(0, chars);
        go(DEL_MS);
        return;
      }
      idx = (idx + 1) % products.length;
      phase = 'typing';
      go(280);
    };

    input.placeholder = '';
    go(400);
    return () => clearTimeout(timer);
  }, [inputRef, active]);
}
